import FingerprintJS from '@fingerprintjs/fingerprintjs';

// 单例缓存 FingerprintJS 实例
let fpPromise: Promise<FingerprintJS.Agent> | null = null;

/**
 * 初始化 FingerprintJS 实例
 */
async function loadFingerprintJS(): Promise<FingerprintJS.Agent> {
  if (!fpPromise) {
    fpPromise = FingerprintJS.load();
  }
  return fpPromise;
}

/**
 * 获取设备指纹（visitorId）
 * 优先使用浏览器指纹，失败时回退到随机 UUID
 */
export async function getDeviceFingerprint(): Promise<string> {
  try {
    // 设置超时（5秒）
    const timeoutPromise = new Promise<never>((_, reject) => {
      setTimeout(() => reject(new Error('FingerprintJS 加载超时')), 5000);
    });

    // 加载指纹库并获取指纹
    const fp = await Promise.race([loadFingerprintJS(), timeoutPromise]);
    const result = await fp.get();
    
    // visitorId 是一个稳定的哈希字符串（约 20-32 字符）
    // 同一台设备的不同浏览器会生成相同的 visitorId
    return result.visitorId;
  } catch (error) {
    console.warn('FingerprintJS 获取失败，回退到随机 UUID:', error);
    
    // 回退方案：使用浏览器原生 crypto.randomUUID()
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return crypto.randomUUID();
    }
    
    // 极旧浏览器回退：生成简单随机字符串
    return Math.random().toString(36).substring(2) + 
           Date.now().toString(36).substring(2);
  }
}

/**
 * 获取设备指纹（同步版本，仅从缓存读取或生成简单指纹）
 * 用于不需要异步等待的场景
 */
export function getDeviceFingerprintSync(): string {
  // 尝试从 localStorage 读取已缓存的设备ID
  const cachedId = localStorage.getItem('device_id');
  if (cachedId) {
    return cachedId;
  }
  
  // 同步无法调用 FingerprintJS（异步），返回临时 ID
  // 实际使用时应该使用异步版本
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  
  return 'temp-' + Math.random().toString(36).substring(2);
}